import { useEffect } from "react";

// Injects a JSON-LD structured-data script for rich search results.
export default function JsonLd({ data, id }) {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [data, id]);
  return null;
}
